import * as Yup from 'yup';

export const fontesRendaValidationSchema = Yup.object().shape({
    outroTexto: Yup.string(),
});

export default fontesRendaValidationSchema;
